import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 公众号 - 登录页
const registerIndex = () =>
  import(
    /* webpackChunkName: "register-index" */ "@/views/teacher/applicationFrom/register/index.vue"
  );
// 公众号 - 获取 area页
const registerGetAreaPage = () =>
  import(
    /* webpackChunkName: "register-area-page" */ "@/views/teacher/applicationFrom/register/getAreaPage.vue"
  );
// 老师应聘流程总览页面
const applicationView = () =>
  import(
    /* webpackChunkName: "application-view" */ "@/views/teacher/applicationFrom/applicationView/index.vue"
  );

// 老师应聘职位选择页
const applyJobViewIndex = () =>
  import(
    /* webpackChunkName: "teacher-resume" */ "@/views/teacher/applicationFrom/applyJobView/index.vue"
  );
// 身份认证页面
const faceRecognation = () =>
  import(
    /* webpackChunkName: "application-view" */ "@/views/teacher/applicationFrom/faceRecognation/index.vue"
  );
// 人脸识别页面
const faceSuccessview = () =>
  import(
    /* webpackChunkName: "application-view" */ "@/views/teacher/applicationFrom/faceRecognation/faceSuccessview.vue"
  );
const applyInstructionsOne = () =>
  import(
    /* webpackChunkName: "teacher-resume" */ "@/views/teacher/applicationFrom/applyJobView/applyInstructionsOne.vue"
  );
const applyInstructionsMore = () =>
  import(
    /* webpackChunkName: "teacher-resume" */ "@/views/teacher/applicationFrom/applyJobView/applyInstructionsMore.vue"
  );
// 公众号 - 应聘的填写信息
const userToApplication = () =>
  import(
    /* webpackChunkName: "user-to-application" */ "@/views/teacher/applicationFrom/userToApplication/index.vue"
  );
// 公众号 - 应聘信息预览
const userToApplicationPreview = () =>
  import(
    /* webpackChunkName: "user-to-application-preview" */ "@/views/teacher/applicationFrom/userToApplication/preview.vue"
  );
// 公众号 - 应聘成功
const userToApplicationOk = () =>
  import(
    /* webpackChunkName: "user-to-application-ok" */ "@/views/teacher/applicationFrom/userToApplicationOk/index.vue"
  );
// 公众号 - 进入入职的第一页
const teacherEntryFromFirst = () =>
  import(
    /* webpackChunkName: "teacher-entry-from-first" */ "@/views/teacher/applicationFrom/teacherEntryFrom/index.vue"
  );
//公众号 -  承诺书
const teacherEntryFromBook = () =>
  import(
    /* webpackChunkName: "teacher-entry-from-book" */ "@/views/teacher/applicationFrom/teacherEntryFrom/book.vue"
  );
//公众号 - 个人信息
const personalInformation = () =>
  import(
    /* webpackChunkName: "personal-information" */ "@/views/teacher/applicationFrom/teacherEntryFrom/personalInformation.vue"
  );
//公众号 - 教学信息
const teachingInformation = () =>
  import(
    /* webpackChunkName: "teaching-information" */ "@/views/teacher/applicationFrom/teacherEntryFrom/teachingInformation.vue"
  );
//公众号 -  授课页面
const giveLessonsInformation = () =>
  import(
    /* webpackChunkName: "give-lessons-information" */ "@/views/teacher/applicationFrom/teacherEntryFrom/giveLessonsInformation.vue"
  );
//公众号 - 入职 预览页面
const previewPage = () =>
  import(
    /* webpackChunkName: "preview-page" */ "@/views/teacher/applicationFrom/teacherEntryFrom/previewPage.vue"
  );
//公众号 - 成功提交
const teacherEntryOk = () =>
  import(
    /* webpackChunkName: "teacher-entry-ok" */ "@/views/teacher/applicationFrom/teacherEntryOk/index.vue"
  );
//公众号 - 入职成功
const teacherEntryPass = () =>
  import(
    /* webpackChunkName: "teacher-entry-pass" */ "@/views/teacher/applicationFrom/teacherEntryOk/pass.vue"
  );
// 通用 - pro简历
const resumeTemplate = () =>
  import(
    /* webpackChunkName: "resume-template" */ "@/views/teacher/applicationFrom/resumeTemplate/index.vue"
  );
// 老师预约考试
const appointmentIndex = () =>
  import(
    /* webpackChunkName: "appointment-index" */ "@/views/teacher/applicationFrom/appointment/index.vue"
  );
// 老师预约考试：预约结果
const appointmentResult = () =>
  import(
    /* webpackChunkName: "appointment-result" */ "@/views/teacher/applicationFrom/appointment/result.vue"
  );
// 老师预约考试：取消预约
const appointmentCancel = () =>
  import(
    /* webpackChunkName: "appointment-cancel" */ "@/views/teacher/applicationFrom/appointment/cancel.vue"
  );
// 老师预约考试：取消预约
const answerOk = () =>
  import(
    /* webpackChunkName: "answer-ok" */ "@/views/teacher/applicationFrom/userToApplication/answerOk.vue"
  );
// 老师应聘面试
const applicationAgreement = () =>
  import(
    /* webpackChunkName: "application-agreement" */ "@/views/teacher/applicationFrom/interview/agreement.vue"
  );
const applicationIntro = () =>
  import(
    /* webpackChunkName: "application-intro" */ "@/views/teacher/applicationFrom/interview/intro.vue"
  );
const applicationAppointment = () =>
  import(
    /* webpackChunkName: "application-appointment" */ "@/views/teacher/applicationFrom/interview/appointment/index.vue"
  );
const applicationResult = () =>
  import(
    /* webpackChunkName: "application-result" */ "@/views/teacher/applicationFrom/interview/appointment/result.vue"
  );
const applicationCancel = () =>
  import(
    /* webpackChunkName: "application-cancel" */ "@/views/teacher/applicationFrom/interview/appointment/cancel.vue"
  );
// 面试官开关时段页面
const interviewAssessmentPeriod = () =>
  import(
    /* webpackChunkName: "teacher-interview" */ "@/views/teacher/applicationFrom/interview/interviewAssessmentPeriod.vue"
  );

export default {
  path: "teacherFrom",
  component: view,
  children: [
    {
      name: "getAreaPage",
      path: "getAreaPage",
      component: registerGetAreaPage
    },
    {
      name: "registerIndex",
      path: "registerIndex",
      component: registerIndex
    },
    {
      name: "faceRecognation",
      path: "faceRecognation",
      component: faceRecognation
    },
    {
      name: "faceSuccessview",
      path: "faceSuccessview",
      component: faceSuccessview
    },
    {
      name: "userToApplication",
      path: "userToApplication",
      component: userToApplication
    },
    {
      name: "userToApplicationPreview",
      path: "userToApplicationPreview",
      component: userToApplicationPreview
    },
    {
      name: "answerOk",
      path: "answerOk",
      component: answerOk
    },
    {
      name: "userToApplicationOk",
      path: "userToApplicationOk",
      component: userToApplicationOk
    },
    {
      name: "teacherEntryFromFirst",
      path: "teacherEntryFromFirst",
      component: teacherEntryFromFirst
    },
    {
      name: "teacherEntryFromBook",
      path: "teacherEntryFromBook",
      component: teacherEntryFromBook
    },
    {
      name: "personalInformation",
      path: "personalInformation",
      component: personalInformation
    },
    {
      name: "teachingInformation",
      path: "teachingInformation",
      component: teachingInformation
    },
    {
      name: "giveLessonsInformation",
      path: "giveLessonsInformation",
      component: giveLessonsInformation
    },
    {
      name: "previewPage",
      path: "previewPage",
      component: previewPage
    },
    {
      name: "teacherEntryOk",
      path: "teacherEntryOk",
      component: teacherEntryOk
    },
    {
      name: "teacherEntryPass",
      path: "teacherEntryPass",
      component: teacherEntryPass
    },
    {
      name: "resumeTemplate",
      path: "resumeTemplate",
      component: resumeTemplate
    },
    {
      name: "applicationView",
      path: "applicationView",
      component: applicationView
    },

    {
      name: "applyJobView",
      path: "applyJobView",
      component: view,
      children: [
        {
          name: "applyJobViewIndex",
          path: "index",
          component: applyJobViewIndex
        },
        {
          name: "applyInstructionsOne",
          path: "instructionsOne",
          component: applyInstructionsOne
        },
        {
          name: "applyInstructionsMore",
          path: "instructionsMore",
          component: applyInstructionsMore
        }
      ]
    },
    {
      name: "appointment",
      path: "appointment",
      component: view,
      children: [
        {
          name: "appointmentIndex",
          path: "index",
          component: appointmentIndex
        },
        {
          name: "appointmentResult",
          path: "result",
          component: appointmentResult
        },
        {
          name: "appointmentCancel",
          path: "cancel",
          component: appointmentCancel
        }
      ]
    },
    {
      name: "interview",
      path: "interview",
      component: view,
      redirect: "interview/agreement",
      children: [
        {
          name: "applicationAgreement",
          path: "agreement",
          component: applicationAgreement
        },
        {
          name: "appointmentIntro",
          path: "intro",
          component: applicationIntro
        },
        {
          name: "applicationAppointment",
          path: "appointment",
          component: view,
          redirect: "appointment/index",
          children: [
            {
              name: "applicationResult",
              path: "result",
              component: applicationResult
            },
            {
              name: "applicationCancel",
              path: "cancel",
              component: applicationCancel
            },
            {
              name: "applicationIndex",
              path: "index",
              component: applicationAppointment
            }
          ]
        },
        {
          name: "interviewAssessmentPeriod",
          path: "interviewAssessmentPeriod",
          component: interviewAssessmentPeriod
        }
      ]
    }
  ]
};
